export type TGlobalModalId =
  // 'FINISH_PROFILE' |
  'CONNECT_SOFTWARE' | 'IMAGE';

export type TAppState = {
  globalModalId: TGlobalModalId | null;
  showGlobalModal: boolean;
  globalModalPayload: any;
  currentLang: TLangSlug;
};

export type TOpenGlobalModalPayload = {
  id: TGlobalModalId;
  data?: any;
};

export const LANG_SK_SLUG = 'sk';
export const LANG_EN_SLUG = 'en';
export const LANG_CS_SLUG = 'cs';

export type TLangSlug = typeof LANG_SK_SLUG | typeof LANG_EN_SLUG | typeof LANG_CS_SLUG;
